import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
@Injectable({
  providedIn: 'root'
})


export class MapMarkerService {
  constructor(private http: HttpClient) {
  }


  getMrt() {
    const params: any = { };
    return this.http.get(environment.url +'/mapSite/getMrt', {params} );
  }

  getThsrc() {
    const trafficList :traffic[] =[];
    trafficList.push({
      position:{
        lat:24.112100,
        lng:120.616200
      },
      name:'臺中',
      staionId:''
    })
    return trafficList;
  }

  getTra() {
    const params: any = { };
    return this.http.get(environment.url +'/mapSite/getTra', {params} );
  }

  getBus() {
    const params: any = { };
    return this.http.get(environment.url +'/mapSite/getBus', {params} );
  }

  getBike() {
    const params: any = { };
    return this.http.get(environment.url +'/mapSite/getBike', {params} );
  }

  getNhpt() {
    const params: any = { };
    return this.http.get(environment.url +'/mapSite/getNhpt', {params} );
  }
}

interface traffic {
  position: {
    lat:number,
    lng:number
  };
  name: string;
  staionId: string;
}
